module.exports = __webpack_public_path__ + "img/rc.64d6a7c4.svg";